export default function PlatformComparison() {
  const platforms = [
    { name: 'CSSBuy Spreadsheet', type: 'Core curated list', strength: 'Most popular', bestFor: 'Beginners', highlight: true },
    { name: 'Kakobuy Spreadsheet', type: 'Trend-based finds', strength: 'Fast updates', bestFor: 'Fashion users', highlight: false },
    { name: 'Superbuy Spreadsheet', type: 'Verified items', strength: 'High reliability', bestFor: 'Premium users', highlight: false },
    { name: 'Oopbuy Spreadsheet', type: 'Budget finds', strength: 'Cheap items', bestFor: 'Budget shoppers', highlight: false },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Multi-Agent Spreadsheet System
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Compare the top agent shopping spreadsheet platforms and find the one that fits your needs.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px] border-collapse">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Platform</th>
                <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Spreadsheet Type</th>
                <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Strength</th>
                <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Best For</th>
              </tr>
            </thead>
            <tbody>
              {platforms.map((p) => (
                <tr
                  key={p.name}
                  className={`border-b border-background-200/50 transition-colors ${p.highlight ? 'bg-primary-50/50' : 'hover:bg-background-100'}`}
                >
                  <td className="py-3.5 px-4">
                    <span className={`text-sm font-semibold ${p.highlight ? 'text-primary-700' : 'text-foreground-900'}`}>
                      {p.name}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-sm text-foreground-600">{p.type}</td>
                  <td className="py-3.5 px-4">
                    <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium">
                      {p.strength}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-sm text-foreground-600">{p.bestFor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}